import Papa from 'papaparse';

const SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTCPYVZwGaZGEPqzS1Vdw4eT1JuWVhyQq2YlYXQdVVRZgYRDjQjosrDYsoJWnTjSSPxUBJ4iaMrlxjg/pub?gid=1023526573&single=true&output=csv';

let cachedData = null;

export const fetchSeoData = async () => {
  if (cachedData) return cachedData; // avoid re-fetching on every route change

  const response = await fetch(SHEET_URL);
  const csvText = await response.text();
  const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });
  cachedData = parsed.data;
  return cachedData;
};